export default "__VITE_ASSET__oXUjUE_u__"